export default __webpack_public_path__ + "static/media/Nunito-Regular.99a3b019.ttf";